<template>
  <div class="my-page-task">
    <div class="task-icon-rounded">
      <i
        class="task-icon budicon"
        :class="{
          'budicon-solid budicon-solid-document-page': type === 'contract',
          'budicon-solid budicon-solid-ui-compose': type === 'top',
          'budicon-solid budicon-solid-announcement': type === 'letting',
          'budicon-solid budicon-solid-file-block': type === 'lease_termination',
          'budicon-savings': type === 'deposit_instabank',
        }"
      ></i>
    </div>
    <div class="heading">
      <h3 v-html="heading"></h3>
    </div>
    <div class="info text-secondary">
      <div class="date">{{ formattedDate }}</div>
      <div class="status">{{ this.statuses[status] || status }}</div>
    </div>
    <div class="buttons">
      <button
        v-for="action in actions"
        :key="action.type"
        :class="['btn', 'btn-sm', actionData[action.type] ? actionData[action.type].style : 'btn-outline-secondary']"
        :disabled="loading"
        @click="$emit('click:action', action)"
      >
        <span>{{ actionData[action.type] ? actionData[action.type].name : action.type }}</span>
        <span
          v-if="loading && loadingActionType === action.type"
          class="spinner-grow spinner-grow-sm"
          role="status"
          aria-hidden="true"
        ></span>
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'MyPageTask',

  props: {
    type: String,
    tenant: Object,
    rentalObject: Object,
    status: String,
    actions: Array,
    modified: String,
    loading: Boolean,
    loadingActionType: String,
  },

  data() {
    return {
      actionData: {
        top_sign: {
          name: 'Signer',
          style: 'btn-primary',
        },
        top_edit: {
          name: 'Rediger',
          style: 'btn-primary',
        },
        top_delete: {
          name: 'Slett',
          style: 'btn-outline-secondary',
        },
        ir_edit: {
          name: 'Rediger',
          style: 'btn-primary',
        },
        ir_delete: {
          name: 'Slett',
          style: 'btn-outline-secondary',
        },
        contract_edit: {
          name: 'Rediger',
          style: 'btn-primary',
        },
        contract_delete: {
          name: 'Slett',
          style: 'btn-outline-secondary',
        },
        contract_cancel_signing: {
          name: 'Avbryt signering',
          style: 'btn-outline-secondary',
        },
        contract_landlord_sign: {
          name: 'Signer',
          style: 'btn-primary',
        },
        lease_termination_edit: {
          name: 'Rediger',
          style: 'btn-primary',
        },
        lease_termination_delete: {
          name: 'Slett',
          style: 'btn-outline-secondary',
        },
        letting_edit: {
          name: 'Rediger',
          style: 'btn-primary',
        },
        letting_delete: {
          name: 'Slett',
          style: 'btn-outline-secondary',
        },
        deposit_instabank_sign: {
          name: 'Signer nå',
          style: 'btn-outline-secondary',
        },
        deposit_account_termination: {
          text: 'Slett',
          type: 'btn-outline-secondary',
        },
      },
      statuses: {
        draft: 'Utkast',
        open: 'Utkast',
        signing_tenant: 'Venter på leietakers signatur',
        signing_landlord: 'Venter på utleiers signatur',
        locked_for_signing: 'Lukket for signering',
        MISSING_SIGNATURE_FROM_ALL: 'Mangler signatur fra begge parter',
        MISSING_SIGNATURE_FROM_TENANT: 'Mangler signatur fra leietaker',
        MISSING_SIGNATURE_FROM_LANDLORD: 'Mangler signatur fra utleier',
        XXX: 'Utkast',
      },
    };
  },

  computed: {
    heading() {
      if (this.type === 'contract') {
        if (this.tenant && this.tenant.fullName) {
          return `Leiekontrakt med ${this.tenant.fullName}`;
        } else {
          return `Påbegynt leiekontrakt for ${this.rentalObject.name}`;
        }
      } else if (this.type === 'letting') {
        return `Annonse for <strong>${this.rentalObject.name}</strong>`;
      } else if (this.type === 'top') {
        return `Overtakelsesprotokoll for <strong>${this.rentalObject.name}</strong> med <strong>${
          (this.tenant && this.tenant.fullName) || 'N/A'
        }</strong>`;
      } else if (this.type === 'lease_termination') {
        return `Oppsigelse av leieforhold med <strong>${this.tenant.fullName}</strong>`;
      } else if (this.type === 'deposit_instabank') {
        return `Depositumskonto med ${this.tenant.givenName} ${this.tenant.familyName}`;
      } else if (this.type === 'deposit_account_termination') {
        return `Avslutt innskuddskonto med ${this.tenant.givenName} ${this.tenant.familyName}`;
      }
      return this.type;
    },
    formattedDate() {
      return moment.utc(this.modified).local().format('DD.MM.YYYY');
    },
  },
};
</script>

<style scoped lang="scss">
.my-page-task {
  display: grid;
  grid-template-columns: 5rem 1fr auto;
  background: white;
  border: 1px solid $gray-200;
  border-radius: $border-radius;
  align-items: center;
  padding: 1.5rem;
  gap: 0.75rem;

  h3 {
    font-size: 1rem;
    margin: 0;
    font-weight: normal;
  }

  .task-icon-rounded {
    grid-column: 1;
    grid-row: 1 / 3;
  }

  .heading {
    grid-column: 2;
    grid-row: 1;
  }

  .info {
    grid-column: 3;
    grid-row: 1 / 3;
    justify-self: end;
    text-align: right;
  }
  .buttons {
    grid-row: 2;
    grid-column: 2 / 3;
  }
}

.task-icon-rounded {
  background: $gray-200;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  grid-column: 1;
  grid-row: 1 / span 2;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, 0.35);

  .task-icon {
    font-size: 1.2rem;
    align-self: center;
  }
}

.buttons {
  > *:not(:last-child) {
    margin-right: 0.75rem;
  }
}

@media screen and (max-width: 620px) {
  .my-page-task {
    display: grid;
    grid-template-columns: 4rem auto;
    grid-template-rows: auto auto auto;
    align-items: center;

    .task-icon-rounded {
      display: none;
    }
    .heading {
      grid-row: 1;
      grid-column: 1 / span 2;
    }
    .info {
      grid-column: 1 / span 2;
      grid-row: 2;
      justify-self: center;
      text-align: center;
      margin-top: 1rem;
    }
    .buttons {
      grid-column: 1 / span 2;
      grid-row: 3;
      justify-self: center;
      margin-top: 1rem;
    }
  }
}
</style>
